/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from 'react'
import { useState, useEffect } from 'react'
import { useIntl } from 'react-intl'
import { toAbsoluteUrl } from '../../../_metronic/helpers'
import { PageTitle } from '../../../_metronic/layout/core'
import {
  ListsWidget2,
  ListsWidget3,
  ListsWidget4,
  ListsWidget6,
  TablesWidget5,
  TablesWidget10,
  MixedWidget8,
  CardsWidget7,
  CardsWidget20,
  ListsWidget26,
  ChartsWidget1,
  ChartsWidget2,
  ChartsWidget3,
  ChartsWidget4,
  ChartsWidget5,
  ChartsWidget6,
  ChartsWidget7,
  ChartsWidget8,
} from '../../../_metronic/partials/widgets'
import axios from 'axios'
import { TotalMember } from './components/TotalMember'
import { TotalBill } from './components/TotalBill'
import { NewMember } from './components/NewMember'
import { ChartBox } from './components/ChartBox'
import { BigChart } from './components/BigChart'
import { TableBox } from './components/TableBox'
import { ListBox } from './components/ListBox'
import { BigChartLine } from './components/BigChartLine'
import { StatisticsWidget4 } from './components/StatisticsWidget4'
import { BigChartLine2 } from './components/BigChartLine2'
import { ListBox2 } from './components/ListBox2'

/*const DashboardPage2 = (data: any) => (
  
)*/

const DashboardWrapper2 = () => {
  const [data, setData] = useState<any>([])
  const intl = useIntl()
  const API_URL = process.env.REACT_APP_API_URL
  const getAPI = async () => {
    const x = await axios.get(`${API_URL}/fixedDashBoard`).then((res) => {
      setData(() => res.data.data)
      console.log(res.data.data)
    })
    //return data.data.data
  }
  useEffect(() => {
    getAPI()
    console.log(data)
  }, [])
  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({ id: 'MENU.DASHBOARD' })}</PageTitle>
      <>
        {/* begin::Row */}
        <div className='row g-5 g-xl-10 mb-5 mb-xl-10'>
          {/* begin::Col */}
          <div className='col-md-6 col-lg-6 col-xl-6 col-xxl-3 mb-md-5 mb-xl-10'>
            <TotalMember
              className='h-md-50 mb-5 mb-xl-10'
              data={
                data.totalMember
                  ? data.totalMember
                  : {
                    all: 0,
                    register: 0,
                    registerPercent: 0,
                    verify: 0,
                    verifyPercent: 0,
                    notRegister: 0,
                    notRegisterPercent: 0,
                  }
              }
            />
            {/*<TotalBill
          className='h-md-50 mb-5 mb-xl-10'
          description='Active Projects'
          data='Active Projects'
          color='#F1416C'
          img={toAbsoluteUrl('/media/patterns/vector-1.png')}
        />*/}
            <ListBox2
              className='h-40'
              data={data.top10 ? data.top10 : []}
              header={['Product', 'No']}
              textHeader='Top 10 Product'
            />
          </div>
          {/* end::Col */}

          {/* begin::Col */}
          <div className='col-md-6 col-lg-6 col-xl-6 col-xxl-3 mb-md-5 mb-xl-10'>
            {/*<ChartBox
          className='h-md-50 mb-5 mb-xl-10'
          //data='Active Projects'
          //color='#F1416C'
          //img={toAbsoluteUrl('/media/patterns/vector-1.png')}
        />*/}
            <ListBox
              className='h-md-50 mb-5 mb-xl-10'
              data={data.newUser ? data.newUser : []}
              textHeader='New Users'
              header={['', '', '']}
            />
            <ListBox2
              className='h-40'
              data={data.averageBill ? data.averageBill : []}
              textHeader='Bills'
              header={['', '', '']}
            />
          </div>
          {/* end::Col */}

          {/* begin::Col */}
          <div className='col-xxl-6'>
            {/*<EngageWidget10 className='h-md-100' />*/}
            <div className='card mb-xl-3' style={{ height: '200px' }} >

              <StatisticsWidget4
                className='card-xl-stretch mb-xl-8'
                svgIcon='element-11'
                color='success'
                description='รายได้รวมต่อเดือน'
                change='750 B'
              />

            </div>
            <BigChartLine className='card mb-xl-3' data={data.sellData ? data.sellData : { col: [], data: [] }} header='Total Sale' />
          </div>

          {/* end::Col */}
        </div>
        {/* end::Row */}

        {/* begin::Row */}

        {/* end::Row */}

        {/* begin::Row */}
        <div className='row gy-5 gx-xl-8'>
          <div className='col-xl-6'>
            <TableBox
              className='card-xxl-stretch mb-5 mb-xl-8'
              data={data.lastedBill ? data.lastedBill : []}
              header={['สั่งซื้อเมื่อ', 'ราคา (บาท)']}
              text='Lates Transaction'
            />
          </div>
          <div className='col-xxl-6'>
            <BigChartLine2 className='card mb-xl-3' data={data.pointData ? data.pointData : { col: [], data: [] }} header='Total Point' />
          </div>
        </div>
        {/* end::Row */}
      </>
    </>
  )
}

export { DashboardWrapper2 }
